<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
  <div class="one-column-width">
    <!-- form start -->
    <v-card class="r_tabsform_card mb-5">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl">
        Become a Mentor</v-card-title
      >
      <hr class="r_form_card_top_hr" />

      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Basic Information</v-card-title
      >

      <div class="row px-5 pt-5 mb-5">
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                :class="nameErr == true ? 'validation-error' : 'validated'"
                @keyup="status($event, 'name')"
                v-model="name"
                placeholder="Full name"
                required
              />
              <p v-if="nameErr" class="text-sm text-danger">
                please enter full name correctly
              </p>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                v-model="dob"
                placeholder="Date of birth"
                onfocus="(this.type='date')"
                onblur="(this.type='text')"
                required
              />
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="email"
                class="r_formtabs_inputs m-0 w-100"
                :class="emailErr == true ? 'validation-error' : 'validated'"
                @keyup="status($event, 'email')"
                v-model="email"
                placeholder="Email address"
              />
              <p v-if="emailErr" class="text-sm text-danger">
                please correct email address
              </p>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="number"
                class="r_formtabs_inputs m-0 w-100"
                :class="cnicErr == true ? 'validation-error' : 'validated'"
                @keyup="status($event, 'cnic')"
                v-model="cnic"
                placeholder="CNIC (without dashes)"
              />
              <p v-if="cnicErr" class="text-sm text-danger">
                please enter correct cnic number (without dashes)
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 pt-5 mt-4">
              <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl">Current Location:</label> -->
              <input
                type="number"
                class="r_formtabs_inputs m-0 w-100"
                :class="phoneErr == true ? 'validation-error' : 'validated'"
                @keyup="status($event, 'phone')"
                v-model="phone"
                placeholder="Contact no."
              />
              <p v-if="phoneErr" class="text-sm text-danger">
                please enter correct contact number
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 pt-0">
              <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                >Current Location:</label
              >
              <v-autocomplete
                v-model="country_id"
                :class="countryErr == true ? 'validation-error' : 'validated'"
                @keyup="status($event, 'country')"
                :items="countries"
                label="Select Country"
                class="r_formtabs_inputs m-0 w-100"
                @change="filterCities(country_id)"
              ></v-autocomplete>
              <p v-if="countryErr" class="text-sm text-danger">
                please select your country
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 pt-5 mt-4">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <v-autocomplete
                v-model="city_id"
                :class="cityErr == true ? 'validation-error' : 'validated'"
                @keyup="status($event, 'city')"
                :items="cities"
                label="Select City"
                class="r_formtabs_inputs m-0 w-100"
              ></v-autocomplete>
              <p v-if="cityErr" class="text-sm text-danger">
                please select your city
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 pl-0">
          <vue-editor
            v-model="personal_summary"
            outlined
            class="r_formtabs_text_area m-0 w-100"
            label="About"
            rows="2"
            placeholder="Personal Summary"
          ></vue-editor>
        </div>
      </div>

      <hr class="r_form_card_top_hr mt-5" />

      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Education</v-card-title
      >

      <div
        class="row p-5"
        v-for="(item, index) in eduForm"
        :key="index"
        refs="eduForm"
      >
        <div class="col-md-4 col-sm-12">
          <!-- <label>Name <span class="text-danger">*</span></label> -->
          <v-autocomplete
            v-model="item.level"
            :items="allLevels"
            label="Select Level"
            class="r_formtabs_inputs m-0 w-100"
          ></v-autocomplete>
        </div>
        <div class="col-md-4 col-sm-12">
          <!-- <label>Name <span class="text-danger">*</span></label> -->
          <v-autocomplete
            v-model="item.program"
            :items="allPrograms"
            label="Select Subject/Program"
            class="r_formtabs_inputs m-0 w-100"
          ></v-autocomplete>
        </div>
        <div class="col-md-4 col-sm-12">
          <!-- <label>Name <span class="text-danger">*</span></label> -->

          <v-autocomplete
            v-model="item.institute"
            :items="allInstitutes"
            label="Select Institute"
            class="r_formtabs_inputs m-0 w-100"
          ></v-autocomplete>
        </div>
        <div class="col-md-3 col-sm-12">
          <!-- <label>Name <span class="text-danger">*</span></label> -->
          <input
            type="text"
            class="r_formtabs_inputs m-0 w-100"
            v-model="item.start_date"
            placeholder="Start Date"
            onfocus="(this.type='date')"
            onblur="(this.type='text')"
            required
          />
        </div>
        <div class="col-md-3 col-sm-12">
          <!-- <label>Name <span class="text-danger">*</span></label> -->
          <input
            type="text"
            class="r_formtabs_inputs m-0 w-100"
            v-model="item.end_date"
            placeholder="End Date"
            onfocus="(this.type='date')"
            onblur="(this.type='text')"
            :disabled="item.in_progress == 1 || item.in_progress == true"
          />
        </div>
        <div class="col-md-3 col-sm-12">
          <input
            type="checkbox"
            :id="index"
            class="mr-3"
            v-model="item.in_progress"
            :checked="item.in_progress == 1 || item.in_progress == true"
          />
          <label :for="index">In Progress</label>
        </div>
        <div class="col-md-3 col-sm-12">
          <!-- <label>Name <span class="text-danger">*</span></label> -->
          <input
            type="text"
            class="r_formtabs_inputs m-0 w-100"
            v-model="item.semester"
            placeholder="Semester/Class"
            :disabled="item.in_progress == 0 || item.in_progress == false"
          />
        </div>
        <div class="col-md-4 col-sm-12">
          <!-- <label>Name <span class="text-danger">*</span></label> -->
          <input
            type="text"
            class="r_formtabs_inputs m-0 w-100"
            v-model="item.obtained_marks"
            placeholder="Obtained Marks"
          />
        </div>
        <div class="col-md-4 col-sm-12">
          <!-- <label>Name <span class="text-danger">*</span></label> -->
          <input
            type="text"
            class="r_formtabs_inputs m-0 w-100"
            v-model="item.total_marks"
            placeholder="Total Marks"
          />
        </div>
        <div class="col-md-4 col-sm-12">
          <!-- <label>Name <span class="text-danger">*</span></label> -->
          <input
            type="text"
            class="r_formtabs_inputs m-0 w-100"
            v-model="item.grades"
            placeholder="CGPA/Grade"
          />
        </div>

        <div class="col-12 pt-0">
          <label class="ml-5 text-white d-block r_formtabs_inputs_lbl"
            >add new row</label
          >
          <button
            class="r_form_add_more_recods_btnnn"
            type="button"
            @click="eduAddNewRow()"
          >
            Add
          </button>
          <button
            v-if="index > 0"
            class="r_cust_del_new_rec_btn"
            type="button"
            @click="eduDeleteRow(index)"
          >
            Delete
          </button>
        </div>
      </div>

      <hr class="r_form_card_top_hr mt-5" />

      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Work experience</v-card-title
      >
      <h4 class="ml-5 text-primary r_formtabs_inputs_lbl">
        Latest work experience:
      </h4>

      <div
        class="row p-5"
        v-for="(item, index) in expForm"
        :key="index"
        refs="expForm"
      >
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                v-model="item.companyName"
                placeholder="Company name"
              />
            </div>
            <div class="col-md-3 col-sm-12">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                v-model="item.designation"
                placeholder="Designation"
              />
            </div>
            <div class="col-md-3 col-sm-12">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                v-model="item.startingDate"
                placeholder="Start date"
                onfocus="(this.type='date')"
                onblur="(this.type='text')"
              />
            </div>
            <div class="col-md-3 col-sm-12">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                v-model="item.endDate"
                placeholder="End date"
                onfocus="(this.type='date')"
                onblur="(this.type='text')"
              />
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12">
          <vue-editor
            v-model="item.description"
            outlined
            class="r_formtabs_text_area m-0 w-100"
            label="About"
            rows="2"
            placeholder="Job description"
          ></vue-editor>
        </div>

        <div class="col-12 pt-0">
          <label class="ml-5 text-white d-block r_formtabs_inputs_lbl"
            >add new row</label
          >
          <button
            class="r_form_add_more_recods_btnnn"
            type="button"
            @click="expAddNewRow()"
          >
            Add
          </button>
          <button
            v-if="index > 0"
            class="r_cust_del_new_rec_btn"
            type="button"
            @click="expDeleteRow(index)"
          >
            Delete
          </button>
        </div>
      </div>

      <hr class="r_form_card_top_hr mt-5" />

      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Skills</v-card-title
      >

      <div
        class="row"
        v-for="(item, index) in skillsForm"
        :key="index"
        refs="skillsForm"
      >
        <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
          <multiselect
            class="slect_home_hero w-100"
            id="multiselectCities"
            v-model="item.job_funcation_ch"
            :height="300"
            :options="jobFunctionsCh"
            :multiple="false"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Profession"
            label="value"
            track-by="value"
            :preselect-first="false"
          >
          </multiselect>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
          <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                >Select skill/s:</label
                > -->

          <multiselect
            class="slect_home_hero overflow-x-h w-100"
            id="multiselectCities"
            v-model="item.skill"
            :height="300"
            :options="allSkills"
            :multiple="false"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Skill"
            label="value"
            track-by="value"
            :preselect-first="false"
          >
          </multiselect>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
          <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                >Experience in years:</label
                > -->
          <input
            type="number"
            v-model="item.experience"
            class="r_formtabs_inputs m-0 w-100"
            placeholder="Experience in years"
            required
          />
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12 pt-0">
          <!-- <label class="ml-5 text-white d-block r_formtabs_inputs_lbl"
                >add new row</label
                > -->
          <button
            class="r_form_add_more_recods_btnnn"
            type="button"
            @click="skillsAddNewRow()"
          >
            Add
          </button>
          <button
            v-if="index > 0"
            class="r_cust_del_new_rec_btn"
            type="button"
            @click="skillsDeleteRow(index)"
          >
            Delete
          </button>
        </div>
      </div>

      <hr class="r_form_card_top_hr mt-5" />

      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Certificates</v-card-title
      >
      <h4 class="ml-5 text-primary r_formtabs_inputs_lbl">
        Latest certificate first:
      </h4>

      <div
        class="row p-5"
        v-for="(item, index) in certificateForm"
        :key="index"
        refs="certificateForm"
      >
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                v-model="item.certificateName"
                placeholder="Company name"
              />
            </div>
            <div class="col-md-3 col-sm-12">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                v-model="item.awardedBy"
                placeholder="Awarding body name"
              />
            </div>
            <div class="col-md-3 col-sm-12">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                v-model="item.startingDate"
                placeholder="Start date"
                onfocus="(this.type='date')"
                onblur="(this.type='text')"
              />
            </div>
            <div class="col-md-3 col-sm-12">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input
                type="text"
                class="r_formtabs_inputs m-0 w-100"
                v-model="item.endDate"
                placeholder="End date"
                onfocus="(this.type='date')"
                onblur="(this.type='text')"
              />
            </div>
          </div>
        </div>
        <div class="col-12 pt-0">
          <label class="ml-5 text-white d-block r_formtabs_inputs_lbl"
            >add new row</label
          >
          <button
            class="r_form_add_more_recods_btnnn"
            type="button"
            @click="certAddNewRow()"
          >
            Add
          </button>
          <button
            v-if="index > 0"
            class="r_cust_del_new_rec_btn"
            type="button"
            @click="certDeleteRow(index)"
          >
            Delete
          </button>
        </div>
      </div>

      <hr class="r_form_card_top_hr mt-5" />

      <div class="row px-5 pt-5">
        <div class="col-md-6">
          <button
            type="button"
            class="r_form_add_more_btnnn m-0"
            @click="formSubmit"
          >
            Save
          </button>
          <router-link
            :to="{ name: 'student-be-mentor' }"
            v-slot="{ href, navigate }"
            class="r_form_cancel_more_btnnn m-0"
          >
            <a :href="href" @click="navigate">
              Cancel
            </a>
          </router-link>
        </div>
      </div>
    </v-card>
    <!-- form end -->
  </div>
</template>

<script>
import AdmissionForm from "@/MainServices/AdmissionForm.js";
import { required, minLength } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";
import GeneralService from "@/MainServices/GeneralService.js";
import IndexService from "@/MainServices/IndexService.js";
import axios from "axios";
import API from "@/core/api";
import Multiselect from "vue-multiselect";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      eduForm: [
        {
          level: "",
          program: "",
          institute: "",
          start_date: "",
          end_date: "",
          in_progress: 0,
          semester: "",
          obtained_marks: "",
          total_marks: "",
          grades: "",
        },
      ],
      skillsForm: [
        {
          profession: "",
          job_funcation_ch: "",
          skill: "",
          experience: "",
        },
      ],
      expForm: [
        {
          companyName: "",
          designation: "",
          startingDate: "",
          endDate: "",
          description: "",
        },
      ],
      certificateForm: [
        {
          certificateName: "",
          awardedBy: "",
          startingDate: "",
          endDate: "",
        },
      ],
      editId: null,
      deleteId: null,
      dialog: false,
      snackbar: false,
      snackBarText: null,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      applicationValues: null,
      personal_summary: "",
      name: "",
      dob: "",
      email: "",
      cnic: "",
      phone: "",
      country_id: "",
      city_id: "",
      area_of_expertise: [],
      interested_in: [],
      industry: [],
      user_id: 0,
      countries: [],
      allCities: [],
      cities: [],
      selected_cities: [],
      saved_cnic: "",
      jobFunctions: [],
      jobFunctionsCh: [],
      jobShifts: [],
      jobIndustries: [],
      allSkills: [],
      allLevels: [],
      allPrograms: [],
      allInstitutes: [],
      nameErr: false,
      emailErr: false,
      cnicErr: false,
      phoneErr: false,
      countryErr: false,
      cityErr: false,
      areaOfExpertiseErr: false,
      interestedInErr: false,
      industryErr: false,
      selectedCitiesErr: false,
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      tokens: [
        "HtDFLJIJNa4mwOEHAw45TLtgLy3Zzi3k85kKZV6p",
        "HtDFLJI54236wOEHAw4grop1Ly3Zzi3k85kKZV6p",
        "HtDF7ybds236wOEHAw4grop1Ly3Zzi3mnbvcZV6p",
        "HtDFpoi8u236wOEHAw4grop1Ly3ZqwertbvcZV6p",
        "HtDFpoi8u236wOE45698rop1Ly3Zqwe52031ZV6p",
        "HtDFpoi8u236wOE45698ropoijhbvcxz2031ZV6p",
        "HtDFpoi8u236wOE45698rop123poi456t031ZV6p",
        "HtDFpoi8u236wOE456qwedsa3456bf8sj031ZV6p",
        "HtDFpoi8u236wOE45698rop12742651erts1ZV6p",
        "HtDFpoi8u236wOE456qwed745632ertuj031ZV6p",
      ],
      token: `Bearer ${localStorage.getItem("token")}`,
    };
  },
  components: { Multiselect, VueEditor },

  computed: {
    ...mapGetters(["currentUser"]),
  },

  methods: {
    getInititalData() {
      AdmissionForm.getStudentApplications()
        .then((res) => {
          this.tableData = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    eduAddNewRow() {
      this.eduForm.push({
        level: "",
        program: "",
        institute: "",
        start_date: "",
        end_date: "",
        in_progress: 0,
        semester: "",
        obtained_marks: "",
        total_marks: "",
        grades: "",
      });
    },
    eduDeleteRow(index) {
      this.eduForm.splice(index, 1);
    },
    skillsAddNewRow() {
      this.skillsForm.push({
        profession: "",
        job_funcation_ch: "",
        skill: "",
        experience: "",
      });
    },
    skillsDeleteRow(index) {
      this.skillsForm.splice(index, 1);
    },
    expAddNewRow() {
      this.expForm.push({
        companyName: "",
        designation: "",
        startingDate: "",
        endDate: "",
        description: "",
      });
    },
    expDeleteRow(index) {
      this.expForm.splice(index, 1);
    },
    certAddNewRow() {
      this.certificateForm.push({
        certificateName: "",
        awardedBy: "",
        startingDate: "",
        endDate: "",
        // cert_description: "",
      });
    },
    certDeleteRow(index) {
      this.certificateForm.splice(index, 1);
    },

    formSubmit() {
      if (
        this.nameErr == false &&
        this.emailErr == false &&
        this.phoneErr == false &&
        this.cnicErr == false &&
        this.countryErr == false &&
        this.cityErr == false
      ) {
        let formData = new FormData();
        formData.append("personal_summary", this.personal_summary);
        formData.append("name", this.name);
        formData.append("email", this.email);
        formData.append("cnic", this.cnic);
        formData.append("saved_cnic", this.saved_cnic);
        formData.append("phone", this.phone);
        formData.append("dob", this.dob);
        formData.append("country_id", this.country_id);
        formData.append("city_id", this.city_id);
        formData.append("educations", JSON.stringify(this.eduForm));

        GeneralService.saveStdMentorProfle(formData)
          .then((res) => {})
          .catch((err) => {});

        let t = this.tokens[Math.floor(Math.random() * 10)];
        let formData1 = new FormData();
        formData1.append("email", this.email);
        formData1.append("cnic", this.cnic);
        formData1.append("saved_cnic", this.saved_cnic);
        formData1.append("token", t);
        formData1.append("skills", JSON.stringify(this.skillsForm));
        formData1.append("experiences", JSON.stringify(this.expForm));
        formData1.append("certificates", JSON.stringify(this.certificateForm));

        axios.defaults.headers.common["Authorization"] = this.token;

        axios
          .post(`${API.API_JOB4U}/std-mentor-profile-store`, formData1)
          .then((res) => {
            Swal.fire({
              title: "",
              text: "Record updated successfully!",
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          })
          .catch((err) => {});
      } else {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },

    fetchDataFromJob4u(e, c) {
      axios.defaults.headers.common["Authorization"] = this.token;
      let t = this.tokens[Math.floor(Math.random() * 10)];

      axios
        .post(`${API.API_JOB4U}/std-career-profile`, {
          token: t,
          email: e,
          cnic: c,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.jobFunctions.length > 0) {
              this.jobFunctions = [];
              this.jobFunctionsCh = [];
              res.data.jobFunctions.map((el) => {
                this.jobFunctions.push({
                  id: el.id,
                  value: el.job_function_name,
                });
                this.jobFunctionsCh.push({
                  id: el.id,
                  value: el.job_function_name,
                  text: el.job_function_name,
                });

                if (
                  res.data.area_of_expertise.indexOf(el.job_function_name) !==
                  -1
                ) {
                  this.area_of_expertise.push({
                    id: el.id,
                    value: el.job_function_name,
                  });
                }
              });
            }

            if (res.data.jobShifts.length > 0) {
              this.jobShifts = [];

              res.data.jobShifts.map((el) => {
                this.jobShifts.push({ id: el.id, value: el.job_shift });

                if (res.data.interested_in.indexOf(el.job_shift) !== -1) {
                  this.interested_in.push({ id: el.id, value: el.job_shift });
                }
              });
            }

            if (res.data.jobIndustries.length > 0) {
              this.jobIndustries = [];
              res.data.jobIndustries.map((el) => {
                this.jobIndustries.push({ id: el.id, value: el.industry_name });

                if (res.data.industry.indexOf(el.industry_name) !== -1) {
                  this.industry.push({ id: el.id, value: el.industry_name });
                }
              });
            }

            this.allCities.map((el) => {
              if (res.data.willing_to_relocate.indexOf(el.value) !== -1) {
                this.selected_cities.push({ id: el.id, value: el.value });
              }
            });

            if (res.data.allSkills.length > 0) {
              res.data.allSkills.map((el) => {
                this.allSkills.push({
                  id: el.id,
                  value: el.skill_name,
                  text: el.skill_name,
                });
              });
            }

            if (res.data.skills.length > 0) {
              this.skillsForm = [];

              for (let i = 0; i < res.data.skills.length; i++) {
                this.skillsForm.push({
                  profession: "",
                  job_funcation_ch: res.data.skills[i].job_funcation_ch,
                  skill: res.data.skills[i].skill,
                  experience: res.data.skills[i].experience,
                });
              }
            }

            if (res.data.work_experience.length > 0) {
              this.expForm = [];
              for (let i = 0; i < res.data.work_experience.length; i++) {
                this.expForm.push({
                  companyName: res.data.work_experience[i].companyName,
                  designation: res.data.work_experience[i].designation,
                  startingDate: res.data.work_experience[i].startingDate,
                  endDate: res.data.work_experience[i].endDate,
                  description: res.data.work_experience[i].description,
                });
              }
            }

            if (res.data.certificate.length > 0) {
              this.certificateForm = [];
              for (let i = 0; i < res.data.certificate.length; i++) {
                this.certificateForm.push({
                  certificateName: res.data.certificate[i].certificateName,
                  awardedBy: res.data.certificate[i].awardedBy,
                  startingDate: res.data.certificate[i].startingDate,
                  endDate: res.data.certificate[i].endDate,
                });
              }
            }
          }
        })
        .catch((err) => {
          // console.log('job4u err', err);
        });
    },

    // getInititalData() {
    //   AdmissionForm.getStudentApplications()
    //     .then((res) => {
    //       this.tableData = res.data;
    //     })
    //     .catch(() => {
    //       this.loading = false;
    //     });
    // },
    // main methods
    // showEditForm(item) {
    //   this.applicationValues = JSON.parse(item.values);
    //   this.editId = item.id;
    //   this.showFormData = true;
    // },
    // cancelForm() {
    //   this.showFormData = false;
    // },
    // askUserAboutDelete(item) {
    //   this.deleteId = item.id;
    //   this.dialog = true;
    // },
    // deleteItem() {
    //   this.deleting = true;
    //   CampusService.deleteCampus(this.deleteId)
    //     .then((res) => {
    //       this.editId = null;
    //       this.deleting = false;
    //       this.dialog = false;
    //       this.resetForm();
    //       this.getInititalData();
    //       this.snackBarText = "Campus Deleted successful!";
    //       this.snackbar = true;
    //     })
    //     .catch((error) => {
    //       this.errorMessage = true;
    //       this.dialog = false;
    //     });
  },
  mounted() {
    // this.getInititalData();

    IndexService.getCountries().then((res) => {
      this.countries = [];
      res.data.map((el) => {
        this.countries.push({ value: el.id, text: el.country });
      });
    });

    IndexService.getCities().then((res) => {
      this.allCities = [];
      this.cities = [];
      res.data.map((el) => {
        this.allCities.push({ id: el.id, value: el.city });
        this.cities.push({ value: el.id, text: el.city });
      });
    });

    GeneralService.getStdCareerProfle()
      .then((res) => {
        if (res.data) {
          this.name = res.data.name;
          this.email = res.data.email;
          this.user_id = res.data.id;
          if (res.data.contact != null) {
            this.phone = res.data.contact;
          }
          if (res.data.cnic != null) {
            this.cnic = res.data.cnic;
            this.saved_cnic = res.data.cnic;
          }
          this.fetchDataFromJob4u(res.data.email, res.data.cnic);

          if (res.data.profile != null) {
            if (res.data.profile.dob != null) {
              this.dob = res.data.profile.dob;
            }
            this.country_id = parseInt(res.data.profile.country);
            this.city_id = parseInt(res.data.profile.city);
            this.personal_summary = res.data.profile.personal_summary;
          }

          if (res.data.educations.length > 0) {
            this.eduForm = [];

            for (let i = 0; i < res.data.educations.length; i++) {
              this.eduForm.push({
                level: res.data.educations[i].level_id,
                program: res.data.educations[i].program_id,
                institute: res.data.educations[i].institute_id,
                start_date: res.data.educations[i].start_date,
                end_date: res.data.educations[i].end_date,
                in_progress: res.data.educations[i].in_progress,
                semester: res.data.educations[i].semester,
                obtained_marks: res.data.educations[i].obtained_marks,
                total_marks: res.data.educations[i].total_marks,
                grades: res.data.educations[i].grades,
              });
            }
          }

          if (res.data.allLevels.length > 0) {
            this.allLevels = [];
            res.data.allLevels.map((el) => {
              this.allLevels.push({ value: el.id, text: el.level });
            });
          }

          if (res.data.allPrograms.length > 0) {
            this.allPrograms = [];
            res.data.allPrograms.map((el) => {
              this.allPrograms.push({ value: el.id, text: el.program });
            });
          }

          if (res.data.allInstitutes.length > 0) {
            this.allInstitutes = [];
            res.data.allInstitutes.map((el) => {
              this.allInstitutes.push({ value: el.id, text: el.name });
            });
          }
        }
      })
      .catch((error) => {
        // console.log("error", error);
      });
  },
};
</script>

<style scoped>
.text-success {
  color: #2eca8b !important;
}
.text-danger {
  color: #a82511 !important;
}
</style>
